/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Card, CardActions, CardContent, FormControl, FormHelperText, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Controller, useForm } from 'react-hook-form';
import deLocale from "date-fns/locale/es";
import { styles } from "./styles";
import { defaultValues } from './models';
import * as yup from "yup";
import Utils from "../../utils/utils";
import { getActiveRegionals } from '../../actions/regional-actions';
import { getCharges } from '../../actions/charge-actions';
import { REQUIRED_MESSAGE } from '../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import { ColorButton } from "../../utils/form/buttonsForm";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import PregnantFilesModal from './pregnantFilesModal';
import { saveLicenceAsync } from '../../actions/licence-motherhood-actions';
import { withRouter } from 'react-router';


const PregnantForm = (props) => {
  const { user, maestras, setMessage, message, setShowMessage, dispatch } = props;
  const _ = require("lodash");
  const classes = styles();
  const [regionales, setRegionales] = useState([]);
  const [licenseFinishDateState, setLicenseFinishDateState] = useState(null);
  const [licenseStartDate, setLicenseStartDate] = useState(null);
  const [maxPossibleDueDate, setMaxPossibleDueDate] = useState(null);
  const [charges, setCharges] = useState([]);
  const [documents, setDocuments] = useState([]);
  var currentDate = new Date();
  currentDate.setMinutes(
    currentDate.getMinutes()
    //  + currentDate.getTimezoneOffset()
  );
  const [maxDate, setMaxDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );
  const [openModal, setOpenModal] = useState(false);
  const [minPossibleDueDate, setMinPossibleDueDate] = useState(Utils.getFormattedDateMMddyyyy(currentDate, "."));

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  useEffect(() => {
    const getAllCharges = async () => {
      const response = await getCharges();
      setCharges(response?.data?.chargeList);
    };
    getAllCharges();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Registro de embarazo",
      breadCrumbSubText: "Registro de embarazo",
      index: 291,
    });
  }, []);

  const schema = yup.object().shape({
    firstName: yup.string().nullable().notRequired(),
    secondName: yup.string().nullable().notRequired(),
    surname: yup.string().nullable().notRequired(),
    secondSurname: yup.string().nullable().notRequired(),
    documentType: yup.string().nullable().notRequired(),
    documentNumber: yup.string().nullable().notRequired(),
    charge: yup.string().nullable().notRequired(),
    contractType: yup.string().nullable().notRequired(),
    regional: yup.string().nullable().notRequired(),
    startDatePregnancy: yup.date().typeError("Fecha inválida").nullable().required(REQUIRED_MESSAGE),
    duration: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    licenseInitDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .required(REQUIRED_MESSAGE),
    licenseFinishDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .notRequired(REQUIRED_MESSAGE),
    possibleDueDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .required(REQUIRED_MESSAGE),
  });

  const { register, handleSubmit, setValue, control, errors, getValues } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const setPersonData = (user) => {
    const data = user.employee;
    setValue("firstName", data.firstName);
    setValue("secondName", data.secondName);
    setValue("surname", data.surname);
    setValue("secondSurname", data.secondSurname);
    setValue("documentType", data.documentType);
    setValue("documentNumber", data.document);
    setValue("charge", data?.charge?.id);
    setValue("regional", data?.regional?.id);
    setValue("contractType", user?.contractTypeFormat?.contractType?.contractTypeDescription);
  };

  useEffect(() => {
    if (user?.employee?.firstName) {
      setPersonData(user);
    };
  },[])


  const handleLicenseFinishDate = (value) => {
    const formData = getValues();
    if (!formData.possibleDueDate || moment(formData.possibleDueDate) < moment(value)) {
      setMaxPossibleDueDate(value);
    }

    const licenseFinishDate = moment(value).add(18, 'weeks')
    setLicenseFinishDateState(licenseFinishDate);
    setValue("licenseFinishDate", licenseFinishDate);
  };

  const handleLicenseStartDate = (value) => {
    setValue("licenseInitDate", null);
    setLicenseStartDate(value);
  };

  const handleDuration = (value) => {
    const currDay = new Date();
    var result = moment(currDay).diff(value, 'weeks');
    setValue("duration", result > 0 ? result : 0);
    setMinPossibleDueDate(value > currentDate ? value : currentDate);
  };

  const onSubmitFinalize = async (data) => {
    const validData = getValues();
    const format1 = "YYYY-MM-DD HH:mm:ss";

    const registerPregnantObject = {
      pregnancyStartDate: moment(data.startDatePregnancy).format(format1),
      estimatedDueDate: moment(data.possibleDueDate).format(format1),
      licenseStartDate: moment(data.licenseInitDate).format(format1),
      licenseEndDate: moment(data.licenseFinishDate).format(format1),
      documentType: data.documentType,
      document: validData.documentNumber,
      gestationTime: parseInt(validData.duration),
      contractType: user?.contractTypeFormat?.contractType?.id,
      contractTypeDescription: user?.contractTypeFormat?.contractType?.contractTypeDescription,
      attachments: documents
    }

    const response = await saveLicenceAsync(registerPregnantObject, dispatch);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setMessage({
        description: `El registro de embarazo se ha generado de forma exitosa.`,
        textButtonSubmit: "Volver",
        handleClick: () => closeModalRedirect(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error
            ? response?.data?.error
            : `El registro no ha sido creado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => closeModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => closeModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const closeModal = () => {
    setShowMessage(false);
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const closeModalRedirect = () => {
    setShowMessage(false);
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
    props.history.push("/dashboard/pregnant");
  };


  const onSubmit = (data) => {
    setShowMessage(true);
    setMessage(() => ({
      open: true,
      description: "¿Está seguro que desea guardar este registro de embarazo? ",
      type: "QUESTION",
      handleClick: () => onSubmitFinalize(data),
      handleClickOut: closeModal,
    }));
  };

  const replaceAttachements = () => {
    setDocuments([]);
    setOpenModal(true);
  }

  const handleClickOpen = () => {
    if (documents?.length > 0) {
      setShowMessage(true);
      setMessage(() => ({
        open: true,
        description: "¿Está seguro que desea reemplazar los adjuntos? ",
        type: "QUESTION",
        handleClick: () => replaceAttachements(),
        handleClickOut: closeModal,
      }));
    } else {
      setShowMessage(false);
      setOpenModal(true);
    }
  };

  const onClose = () => {
    setOpenModal(false);
  };

  const showAttachements = () => {
    if (documents?.length > 0) {
      return (
        <Card style={{maxWidth: 325, marginTop: 20, marginLeft: 13}}>
          <CardContent>
            <Typography className={classes.title} color="textSecondary" gutterBottom>
              Documentos Adjuntos
            </Typography>
            {documents.map(document => (
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                {`* ${document.attachedName}`}
              </Typography>))
            }
          </CardContent>
        </Card>
      )
    }
  }

  return (
    <React.Fragment>
      <form
        id="generatePermission"
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
      >
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Primer nombre"
                name="firstName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
                helperText={
                  errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Segundo nombre"
                name="secondName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
                helperText={
                  errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Primer apellido"
                name="surname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("surname") &&
                  errors["surname"].message
                }
                helperText={
                  errors.hasOwnProperty("surname") && errors["surname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Segundo apellido"
                name="secondSurname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
                helperText={
                  errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("charge") && errors["charge"].message
              }
            >
              <InputLabel htmlFor="outlined-select-charge" shrink={true}>
                Cargo *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                size="small"
                name="charge"
                label="Cargo *"
                notched={true}
                disabled={true}
                className={classes.formField}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  name: "stateId",
                  id: "outlined-select-charge",
                }}
                as={
                  <Select>
                    {charges.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("gender") && errors["gender"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("documentType") &&
                errors["documentType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de Documento
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Tipo de Documento"
                name="documentType"
                disabled={true}
                size="small"
                notched={true}
                onChange={(event) => alert(event.target.value)}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  name: "documentType",
                  id: "outlined-select-documentType",
                }}
                as={
                  <Select>
                    {maestras.tipoDocumnetoIdentificacion.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={document.key}
                        value={document.key}
                      >
                        {document.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
                label="Número de Documento"
                name="documentNumber"
                size="small"
                error={
                  !!errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
                helperText={
                  errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
                label="Tipo de Contrato"
                name="contractType"
                size="small"
                error={
                  !!errors.hasOwnProperty("contractType") &&
                  errors["contractType"].message
                }
                helperText={
                  errors.hasOwnProperty("contractType") &&
                  errors["contractType"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regional") &&
                errors["regional"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regional" shrink={true}>
                Regional *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Regional *"
                disabled={true}
                size="small"
                name="regional"
                style={{ backgroundColor: "#ffffff" }}
                notched={true}
                inputProps={{
                  name: "shoeSize",
                  id: "outlined-select-regional",
                }}
                as={
                  <Select>
                    {regionales.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("regional") &&
                  errors["regional"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            md={9}
            lg={9}
          >&nbsp;</Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    style={{ backgroundColor: "#ffffff" }}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}

                    format="dd/MM/yyyy"
                    dateFormat="DD/MM/YYYY"
                    label="Fecha inicio de embarazo *"
                    InputLabelProps={{ shrink: true }}
                    onAccept={handleDuration}
                    error={
                      !!errors.hasOwnProperty("startDatePregnancy") &&
                      errors["startDatePregnancy"].message
                    }
                    helperText={
                      errors.hasOwnProperty("startDatePregnancy") &&
                      errors["startDatePregnancy"].message
                    }
                    maxDate={maxDate}
                  />
                }
                control={control}
                name="startDatePregnancy"
                defaultValue={null}
                placeholder="Fecha inicio de embarazo *"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
                style={{ backgroundColor: "#ffffff" }}
                label="Tiempo de gestación *"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Semana(s)</InputAdornment>,
                }}
                name="duration"
                size="small"
                error={
                  !!errors.hasOwnProperty("duration") &&
                  errors["duration"].message
                }
                helperText={
                  errors.hasOwnProperty("duration") &&
                  errors["duration"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    InputProps={{ readOnly: true }}
                    format="dd/MM/yyyy"
                    inputVariant="outlined"
                    variant="inline"
                    style={{ backgroundColor: "#ffffff" }}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    label="Fecha posible de parto *"
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("possibleDueDate") &&
                      errors["possibleDueDate"].message
                    }

                    helperText={
                      errors.hasOwnProperty("possibleDueDate") &&
                      errors["possibleDueDate"].message
                    }
                    onAccept={handleLicenseStartDate}
                    minDate={minPossibleDueDate}
                  />
                }
                control={control}
                className={classes.formField}
                defaultValue={null}
                name="possibleDueDate"
                placeholder="Fecha posible de parto *"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    InputProps={{ readOnly: true }}
                    style={{ backgroundColor: "#ffffff" }}
                    format="dd/MM/yyyy"
                    label="Fecha de inicio de licencia *"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    onAccept={handleLicenseFinishDate}
                    error={
                      !!errors.hasOwnProperty("licenseInitDate") &&
                      errors["licenseInitDate"].message
                    }
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    helperText={
                      errors.hasOwnProperty("licenseInitDate") &&
                      errors["licenseInitDate"].message
                    }
                    minDate={licenseStartDate}
                  />
                }
                control={control}
                name="licenseInitDate"
                placeholder="Fecha de inicio de licencia *"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    readOnly
                    disabled={true}
                    InputProps={{ readOnly: true }}
                    style={{ backgroundColor: "#ffffff" }}
                    format="dd/MM/yyyy"
                    label="Fecha de finalización de licencia *"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("licenseFinishDate") &&
                      errors["licenseFinishDate"].message
                    }
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    helperText={
                      errors.hasOwnProperty("licenseFinishDate") &&
                      errors["licenseFinishDate"].message
                    }
                    minDate={licenseFinishDateState}
                    maxDate={licenseFinishDateState}
                  />
                }
                control={control}
                name="licenseFinishDate"
                defaultValue={null}
                placeholder="Fecha de finalización de licencia *"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            xs={12}
            md={9}
            lg={9}

          >&nbsp;</Grid>
          <Grid item xs={12} md={12} lg={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <ColorButton
              style={{
                width: "100px",
                marginRight: "20px"
              }}
              onClick={handleClickOpen}
            >
              ADJUNTAR
            </ColorButton>
            <Button
              style={{
                backgroundColor: "transparent",
                color: "#7EBDCE",
                width: "100px",
                marginRight: "20px",
              }}
              onClick={() => { props.history.push("/dashboard/pregnant")}}
              variant="outlined"
            >
              SALIR
            </Button>
            <ColorButton
              style={{
                width: "100px",
                marginRight: "20px"
              }}
              type="submit"
            >
              GUARDAR
            </ColorButton>
          </Grid>
        </Grid>
      </form>
      {showAttachements()}
      {openModal && (
        <PregnantFilesModal
          open={openModal}
          handleClose={onClose}
          setShowMessage={setShowMessage}
          message={message}
          setMessage={setMessage}
          setDocuments={setDocuments}
          documents={documents}
        />
      )}
    </React.Fragment>
  );
};

export default withRouter(PregnantForm)